// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
// ?import '@/polyfills';

// Notifications plugin. Used on Notifications page
import Toastr from "@/components/toastr";
// Validation plugin used to validate forms
import { configure } from "vee-validate";

// A plugin file where you could register global components used across the app
import GlobalComponents from "./globalComponents";

// A plugin file where you could register global directives
import GlobalDirectives from "./globalDirectives";

import SideBar from "@/layouts/sidebar";

// element ui language configuration
// ?import lang from 'element-ui/lib/locale/lang/en';
// ?import locale from 'element-ui/lib/locale';
// ?locale.use(lang);

// vue-bootstrap
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

// asset imports
import "@/assets/sass/argon.scss";
import "@/assets/css/nucleo/css/nucleo.css";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import { messages } from "vee-validate/dist/locale/en.json";

import { APP_CONFIG } from "@/config";

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule], // assign message
  });
});
export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    Vue.use(Toastr);
    Vue.use(BootstrapVue);
    Vue.use(IconsPlugin);
    configure({
      classes: {
        valid: "is-valid",
        invalid: "is-invalid",
        dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
      },
    });

    // Register app configuration
    Vue.prototype.$appConfig = APP_CONFIG;
  },
};
